    define('views/modules/questionnaire/questions/edit/question-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/toastr-service',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/questionnaire/questions/edit/question-edit-form',
    'views/parts/form/button',
    // templates
    'text!templates/modules/questionnaire/questions/edit/question-edit-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    ToastrService,
    // views
    VMenuSaveAction,
    VQuestionEditForm,
    VButton,
    // templates
    TQuestionEditContent
) {

    var VQuestionEditContent = Backbone.View.extend({
        template: TQuestionEditContent,

        regions: {
            root: ".question-edit-content",
            menu: ".menu-actions",
            form: ".question-edit-form",
            button: ".save-and-add-button"
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                group: this.options.group,
                questionnaire: this.options.questionnaire
            });

            this.collection = this.questionnaire.getQuestions();

            var model = this.model,
                optionsCollection = this.optionsCollection = model.getOptions(),
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveButton,
                        saveText: 'Save',
                        tooltip: {
                            container: this.regions.root,
                        }
                    }),
                    form: new VQuestionEditForm({
                        model: model,
                        collection: optionsCollection
                    }),
                    button: new VButton({
                        label: "questionnaire:Save and add another question",
                        callback: this.onSaveAndAddQuestionClick,
                        context: this,
                        icon: 'fa fa-plus',
                        class: 'btn-link',
                        tcClass: false,
                        block: true
                    }),
                };

            this.optionsCollectionCopy = optionsCollection.toJSON();

            this.listenTo(model, {
                'change': this.onModelChange,
                'model:reset': this.onModelReset
            });

            this.listenTo(optionsCollection, { 'update change': this.onCollectionChange });
            this.listenTo(this.questionnaire, { 'sync': this.onQuestionnaireSync });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.button, zone.$button)
                .assign(view.form, zone.$form);

            this.createModelMaster()
                .updateSaveButtons();

            return this;
        },

        prepareQuestions: function() {
            this.setOptions();
            // Add new created question to existing ones
            this.collection.add(this.model.toJSON(), { merge: true });
        },

        saveQuestionnaire: function(options) {
            this.prepareQuestions();
            this.questionnaire.save({ questions: this.collection.toArray() }, _.extend({
                patch: true,
                success: this.onSuccess,
                context: this,
            }, options));
        },

        setOptions: function() {
            var model = this.model,
                newOptions = this.view.form.getOptions();
            // set new options or delete old ones.
            model.set('options', model.isOptionsEnabled() ? newOptions : undefined);
        },

        updateSaveButtons: function() {
            var view = this.view;
            view.menu.toggleSaveButton(!this.isDirty());
            // view.button.toggleDisabled(!this.isDirty());
        },

        isDirty: function() {
            return Boolean(this.modelMaster.changedAttributes(this.model.attributes)) ||
                !this.optionsCollection.equals(this.optionsCollectionCopy);
        },

        createModelMaster: function() {
            if (!this.modelMaster) {
                this.modelMaster = this.model.clone();
            }
            return this;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function(model) {
            var modelMaster = this.modelMaster,
                view = this.view.form;
            if (!modelMaster) {
                this.modelMaster = modelMaster = model.clone();
            }
            this.updateSaveButtons();
        },

        onCollectionChange: function() {
            this.updateSaveButtons();
        },

        collectionHasNullValues: function() {
            var hasNullvalues = false;
            this.optionsCollection.models.forEach(function(k) {
                if (_.isEmpty(k.get('text'))) {
                    hasNullvalues = true;
                }
            });
            return hasNullvalues;
        },

        performValidation: function() {
            if (this.collectionHasNullValues()) {
                ToastrService.error('questionnaire:questionnaire-options-cannot-be-blank');
                return false;
            }

            if (this.model.get('name') === '') {
                ToastrService.error('questionnaire:questionnaire-name-cannot-be-empty');
                return false;
            }
            if (!this.model.isValid()) {
                U.warn(this.model.validationError);
                return false;
            }

            return true;
        },

        onSaveButton: function() {
            if (this.performValidation()) {
                this.saveQuestionnaire();
            }
        },

        onSaveAndAddQuestionClick: function() {
            if (this.performValidation()) {
                this.saveQuestionnaire({
                    success: this.onSaveAndAddSuccess
                });
            }
        },

        onSaveAndAddSuccess: function() {
            this.trigger('question:add');
        },

        onSuccess: function() {
            this.trigger('form:success');
            this.model.reset();
        },

        onModelReset: function(model) {
            this.createModelMaster();
            this.modelMaster.reset(model.attributes);

            var optionsCollection = this.optionsCollection;
            optionsCollection.reset(model.getOptions().models);
            this.optionsCollectionCopy = optionsCollection.toJSON();
        },

        onQuestionnaireSync: function(model, response, options) {
            this.collection.reset(model.getQuestions().models);
        },
    });

    return VQuestionEditContent;

});

